import FeaturedEvent from './featured-event';

export default FeaturedEvent;
